import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, TrendingUp, Receipt, User, Zap } from 'lucide-react';

const BottomNav = ({ active }) => {
  const navigate = useNavigate();

  const navItems = [
    { id: 'home', label: 'Home', icon: Home, path: '/home' },
    { id: 'trade', label: 'Trade', icon: Zap, path: '/trading-hub' },
    { id: 'market', label: 'Market', icon: TrendingUp, path: '/market' },
    { id: 'transaction', label: 'Transaction', icon: Receipt, path: '/transactions' },
    { id: 'personal', label: 'Personal', icon: User, path: '/profile' },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-slate-900/95 backdrop-blur-sm border-t border-cyan-500/20 z-20">
      <div className="flex items-center justify-around py-2">
        {navItems.map(item => {
          const Icon = item.icon;
          const isActive = active === item.id;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center gap-1 py-2 px-4 transition-all ${
                isActive ? 'neon-icon' : ''
              }`}
            >
              <Icon
                className={`w-6 h-6 transition-all ${
                  isActive ? 'text-cyan-400' : 'text-cyan-700'
                }`}
                style={isActive ? {
                  filter: 'drop-shadow(0 0 8px rgba(34, 211, 238, 0.6))'
                } : {}}
              />
              <span
                className={`text-xs ${
                  isActive ? 'text-cyan-400 font-semibold' : 'text-cyan-700'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;